import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="footer-logo-icon" aria-hidden="true">◈</span>
          <span className="footer-logo-text">Trenda</span>
        </div>

        <nav className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/support">Support</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <a href="mailto:support@betterinsights.app">Contact</a>
        </nav>

        <p className="footer-disclaimer">
          <strong>Caution:</strong> Trenda is not a medical device and is not intended to
          diagnose, treat, cure, or prevent any disease. Dosing decisions should not be made
          based on this app alone. Always consult a qualified healthcare professional.
        </p>

        <p className="footer-copy">
          © {new Date().getFullYear()} Trenda. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
